export default __webpack_public_path__ + "static/media/pulse-black.aede70b3.svg";